import Axios from 'axios';

export class DirectoryApi {
  getDirectoryData(jsonName: any) {
    return Axios.get(
      `${process.env.REACT_APP_SITEMAP_HOST}/json/${jsonName}.json`
    ).then(resp => {
      return resp.data;
    });
  }

  getDirectoryGMSData(jsonName: any) {
    return Axios.get(
      `${process.env.REACT_APP_SITEMAP_HOST}/gms/${jsonName}.json`
    ).then(resp => {
      return resp.data;
    });
  }
}
